<div class="relative z-10 flex flex-row w-full py-5 bg-white" *ngIf="type==='title' && !centered">
    <h1 class="text-3xl font-semibold text-gray-700 md:text-4xl">{{title}}</h1>
    <div class="relative right-0 flex-1 mt-5 ml-5 border-t-2 border-gray-200 md:border-t-4"></div>
</div>
<div class="relative z-10 flex flex-col items-center w-full py-5 bg-white" *ngIf="type==='title' && centered">
    <h1 class="text-3xl font-semibold text-center text-gray-700 md:text-4xl">{{title}}</h1>
</div>